export default __webpack_public_path__ + "static/media/t_audio.68df6eb0.png";